module.exports = __webpack_public_path__ + "static/img/fe.fcd8739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fe.png
// module id = NnhL
// module chunks = 1